<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content">
        <div class="go-back" @click="goBack">返回</div>
        <div class="header_box">
          <div style="width: 100%">
            <div class="main-title">营业执照</div>
          </div>
        </div>
        <!-- 列表 -->
        <div class="invitation-table">
          <div class="image" v-if="license_pic">
            <el-image :src="$imgUrl + license_pic"></el-image>
            <div class="upload-span">
              <span
                class="upload-icon"
                @click.stop="handlePictureCardPreview($imgUrl + license_pic)"
                ><i class="el-icon-zoom-in"></i
              ></span>
              <span
                class="upload-icon"
                @click.stop="handleRemove()"
                style="margin-left: 20px"
                ><i class="el-icon-delete"></i
              ></span>
            </div>
          </div>

          <div v-if="!license_pic">
            <el-upload
              :action="$Url"
              list-type="picture-card"
              :headers="headers"
              :multiple="false"
              :on-success="handleLogoSuccess"
              :on-error="handleLogoError"
              :show-file-list="false"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </div>

          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>

          <el-button @click="submit">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { editPic, companyDetails } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "nameTag",
  data() {
    return {
      fileList: [],
      license_pic: "",
      loading: false,
      active: 2,
      dialogImageUrl: "",
      dialogVisible: false,
      headers: {},
      mark: "",
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "aptitude";
    });
    this.active = index;
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.mark = this.$route.query.mark;

    this.getdetail();
  },
  created() {},
  methods: {
    //获取详情
    getdetail() {
      companyDetails()
        .then((res) => {
          if (res.data.code == 1) {
            let { data } = res.data;
            if (data.license_pic) {
              this.license_pic = data.license_pic;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //关闭
    handleClose() {
      this.dialogVisible = false;
    },
    // 保存
    submit() {
      console.log(this.fileList, "fileList");
      if (!this.license_pic) {
        this.$message.warning("请上传营业执照");
      } else {
        let mark = this.mark;

        // console.log(this.fileList,"this.fileListhis.fileLis")
        let license_pic = this.license_pic;
        editPic({ license_pic, mark })
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.goBack();
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //删除
    handleRemove() {
      this.license_pic = "";
    },
    // 上传成功
    handleLogoSuccess(resData) {
      this.license_pic = resData.data.url;
      console.log(this.license_pic, " this.license_pic");
    },
    // 上传失败
    handleLogoError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    // 返回
    goBack() {
      this.$router.back();
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;
  /deep/ .el-image {
    width: 148px;
    height: 148px;
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}

.pagination_box {
  text-align: right;
  margin-top: 50px;
}
.goods_name {
  line-height: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
.tname {
  font-size: 14px;
  font-weight: 400;
  color: #000;
  margin-top: 15px;
}
.inputtime {
  font-size: 12px;
  font-weight: 400;
  color: #969696;
  margin-top: 10px;
  line-height: 18px;
}
.p_footer {
  display: flex;

  .p_item_footer {
    width: 50%;
    height: 64px;
    line-height: 64px;
    text-align: center;
  }
  .p_item_footer:nth-child(1) {
    border-right: 2px solid #eee;
  }
}
.header_box {
  width: 100%;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}
.create-btn {
  width: 148px;
  height: 42px;
  color: #fff;
  font-size: 19px;
  font-weight: 500;
  cursor: pointer;
  line-height: 42px;
  text-align: center;
  background: #1677ff;
  border-radius: 4px;
  &:hover {
    text-decoration: underline;
  }
}
.content-type {
  padding-bottom: 35px;
  .main-title {
    width: 100%;
    margin-top: 40px;
  }
}
.p_list {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  // background: #fff;
  // border-radius: 8px;
  padding: 20px 0 0;
  box-sizing: border-box;
}
.p_item {
  width: -webkit-calc((100% - 20px * 4)/ 4);
  width: calc((100% - 20px * 4) / 4);
  margin: 0 20px 20px 0;
  background: #fff;
  border-radius: 8px;
  padding: 20px 0 0;
  box-sizing: border-box;
}
.p_item_top {
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .select_box {
    width: 80px;
  }
}
.p_item_scoend {
  margin-top: 10px;
  padding: 0 15px 15px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border-bottom: 2px solid #eee;
  img {
    width: 100px;
    height: 100px;
    border-radius: 10px;
    margin-right: 20px;
  }
}
.search-wrap {
  width: 100%;
  background: #fff;
  border-radius: 8px;
  margin-top: 50px;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  box-sizing: border-box;

  margin-bottom: 20px;
  .search-input {
    align-items: center;
  }
  .search-input .search-btn {
    width: 130px;
    height: 42px;

    cursor: pointer;
    font-size: 19px;
    margin-right: 11px;
    line-height: 42px;
    text-align: center;
    // background: #2c2c2e;
    border-radius: 4px;
    &:hover {
      text-decoration: underline;
    }
  }
  .search {
    background: #008dff;
    color: #fff;
  }
  .reset {
    color: #2690e6;
    border: 1px solid #008dff;
    margin-left: 11px;
  }
}
.invitation-table {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-sizing: border-box;
  margin-top: 22px;
}
</style>
  <style lang="scss">
.search-wrap {
  .search-input {
    .el-input {
      font-size: 14px;
      width: 40%;
    }
    .el-input__inner {
      height: 42px;
      line-height: 42px;
      border-radius: 4px;
    }
  }
}
.invitation-table .el-pagination {
  margin-top: 30px;
  text-align: center;
  .el-pager li,
  .el-pagination__total {
    font-size: 14px;
  }
  .el-pagination__jump {
    font-size: 14px;
  }
}
.my-table {
  color: #888;
  font-size: 18px;
  margin-top: 30px;
}
.my-table tbody td,
.my-table tbody th {
  height: 70px;
  padding: 5px 0;
  box-sizing: border-box;
}
.my-table tbody th,
.my-table tbody tr {
  background: #f2f6fb;
}
.my-table tbody tr.is-new {
  color: #0e0e0e;
}
.check-btn {
  color: #1677ff;
  cursor: pointer;
  margin-left: 20px;
}
.check-btn:hover {
  text-decoration: underline;
}
.check-del {
  color: #ff4d4f;
}
.my-table tbody tr td .check-btn {
  color: #1677ff;
  cursor: pointer;
}
.my-table tbody tr td .check-btn:hover {
  text-decoration: underline;
}
.my-table tbody tr td .check-btn.check-del {
  color: #ff4d4f;
  // margin-left: 50px;
}
.el-table--striped .el-table__body tr.el-table__row--striped td {
  background: #fff;
}
.el-table td,
.el-table th.is-leaf {
  border-bottom: 0 none;
}
/* 表格最外层边框-底部边框 */
.el-table--border::after,
.el-table--group::after {
  width: 0;
}
.my-table::before {
  width: 0;
}
.my-table tbody tr td:first-child {
  border-radius: 10px 0 0 10px;
}
.my-table tbody tr td:last-child {
  border-radius: 0 10px 10px 0;
}
@media only screen and (max-width: 1366px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 20px * 3)/ 3) !important;
    width: calc((100% - 20px * 3) / 3) !important;
    margin: 0 20px 20px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1280px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 15px * 2)/ 2) !important;
    width: calc((100% - 15px * 2) / 2) !important;
    margin: 0 15px 15px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 1200px) {
  .p_list {
    width: 100% !important;
  }
  .p_item {
    width: -webkit-calc((100% - 15px * 2)/ 2) !important;
    width: calc((100% - 15px * 2) / 2) !important;
    //   margin: 0 15px 15px 0 !important;
    background: #fff;
    border-radius: 8px;
    padding: 20px 0 0;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 767px) {
  .invitation-table {
    width: 94%;
  }
  .el-pagination {
    padding: 2px 23px !important;
  }
  .p_item_footer {
    height: 54px !important;
    line-height: 54px !important;
    font-size: 14px !important;
  }
  .tname {
    margin-top: 10px !important;
  }
  .inputtime {
    margin-top: 10px !important;
  }
  .p_item_scoend img {
    width: 80px !important;
    height: 81px !important;
    margin-right: 15px !important;
  }
  .create-btn {
    width: 120px !important;
    height: 40px !important;
    font-size: 15px !important;
  }
  .search-wrap .search-input .search-btn {
    width: 130px !important;
    height: 40px !important;
    font-size: 15px !important;
  }
  .content {
    padding: 30px 0 130px 0;
  }
  .p_item {
    width: 100% !important;
    margin: 0 auto 20px !important;
  }
  .p_list {
    width: 100% !important;
    margin-left: 0 !important;
    display: inline-block !important;
  }
  .search-wrap {
    width: 100% !important;
    margin: 0 auto !important;
  }
  .search-input {
    flex-wrap: wrap;
  }
  .el-input__inner {
    // width: 90% !important;
    margin: 20px 0;
  }
  .main-sub {
    width: 100%;
    padding-bottom: 8px !important;
  }
  .header_box {
    padding-bottom: 50px !important;
  }
  .create-btn {
    margin-bottom: 20px !important;
    position: absolute;
    right: 24px;
    bottom: 0;
  }
  .search-wrap .search-input .el-input {
    width: 100% !important;
  }
}
</style>
  <style>
@media only screen and (max-width: 767px) {
  .el-pagination {
    padding: 2px 23px !important;
  }
}
</style>